var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon downloads white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-downloads-white",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.25,21.9767857 C36.1166667,16.278125 31.0666667,12 25,12 C20.1833333,12 16,14.7089286 13.9166667,18.6732143 C8.9,19.2017857 5,23.4138393 5,28.5178571 C5,33.9852679 9.48333333,38.4285714 15,38.4285714 L36.6666667,38.4285714 C41.2666667,38.4285714 45,34.7285714 45,30.1696429 C45,25.8089286 41.5833333,22.2741071 37.25,21.9767857 Z M33.3333333,26.8660714 L25,35.125 L16.6666667,26.8660714 L21.6666667,26.8660714 L21.6666667,20.2589286 L28.3333333,20.2589286 L28.3333333,26.8660714 L33.3333333,26.8660714 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.375a3d6da08e428cb56ce81054eb8309.svg";
export { ForwardRef as ReactComponent };